import * as React from 'react';
import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import { makeStyles } from '@material-ui/core/styles';
import CardContent from '@mui/material/CardContent';

const useStyles = makeStyles({
  card: {
    marginBottom: 8,
  },
});

export default function Execute(props) {  
  const css = useStyles();

  function showDetails(obj){
    props.showDetails(obj);
  }

  function dateFormat(datetime){
    if(datetime && datetime!=null){
      let datetimeArr = datetime.split(" ");
      let dtArr = datetimeArr[0].split("-");
      let tmArr = datetimeArr[1].split(":");
      datetime = dtArr[2]+"-"+dtArr[1]+"-"+dtArr[0]+" "+tmArr[0]+":"+tmArr[1];
    }
    return datetime;
  }

  return (<>
    <Box >
      {(props.rows && props.rows.length>0)?<>
          {(props.rows || []).map((myObj,i)=>(
            <Card key={'crd'+i} className={css.card} style={{cursor:'pointer'}} onClick={()=>{showDetails(myObj)}} >
              <CardContent>
                <b>{myObj.testTitle}</b><br/>
                Date: {dateFormat(myObj.testDateTime)}, 
                {myObj.testType===2?<>
                 Question Type: {myObj.questionType},
                 Total Marks: {myObj.totalMark}, 
                </>:null} 
                 Duration (Minutes): {myObj.totalTime}
              </CardContent>
            </Card>      
          ))} 
      </>:<>No row found</>} 
    </Box>
  </>);
}